import { render, staticRenderFns } from "./StudentLeaveAdd.vue?vue&type=template&id=2278ecf2&"
import script from "./StudentLeaveAdd.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveAdd.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StudentLeaveAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports